import { useVendorAuth } from "../features/auth";
import { useGlobalChatRealtime } from "../hooks/useGlobalChatRealtime";
import { useGlobalNotificationRealtime } from "../hooks/useGlobalNotificationRealtime";

/**
 * ChatRealtimeLoader
 *
 * A headless component that initializes the global chat and notification realtime hooks.
 * It must be placed inside a DashboardAuthProvider or EmbedAuthProvider.
 */
export function ChatRealtimeLoader() {
  const { currentUser } = useVendorAuth();

  // Initialize global realtime listener for the current user
  useGlobalChatRealtime(currentUser?.id);
  useGlobalNotificationRealtime(currentUser?.id);

  return null;
}
